module.exports = __webpack_public_path__ + "static/media/icon_list_thumbnail.36e0ebf0.svg";